import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMediumDown32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M9.646 12.646a.5.5 0 0 0 0 .708L16 19.707l6.354-6.353a.5.5 0 0 0-.708-.708L16 18.293l-5.646-5.647a.5.5 0 0 0-.708 0" /></SvgIcon>;
};
const Memo = memo(SvgArrowMediumDown32);
export default Memo;